import React, { useCallback, useContext } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { LogoMark, LogoText } from '../svg';
import { Button, Icon } from 'scorer-ui-kit';
//import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import LanguageSwitch from '../components/atoms/LanguageSwitch';
import { MenuContext, SidebarOpenContext } from '../App';
import useLocalStorage from '../hooks/useLocalstorage';
import { useRef } from 'react';

import axios from 'axios';
import { API_ENDPOINT } from '../utils/Constants';

const Container = styled.div<{ sidebarOpen: boolean }>`
  border-right: 1px solid hsla(0, 0%, 84%, 50%);
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  transition: 0.3s;
  scrollbar-width: thin;
  box-shadow: inset 0 0 20px 0 rgba(178, 201, 217, 0.15);
  background-color: #eff4f7;
  z-index: 98;
  ${({ sidebarOpen }) => sidebarOpen ? css`
  width: 280px;
  ` :
    css`
  width: 0px;
  margin-right: -280px;
  `};
`;

const InnerContainer = styled.span`
  display: contents;
`;

const Layout = styled.div`
  height: auto;
  width: 100%;
  margin-right: -280px;
`;

const LogoContainer = styled.div`
  border-bottom: 1px solid hsla(0, 0%, 84%, 50%);
  padding: 0 20px 17px 0;
  display: flex;
  flex-direction: row;
  cursor: pointer;
`;

export const SidebarBox = styled.div<{ flex?: string }>`
  position: relative;
  padding: 23px 0 0px 20px;
  ${({ flex }) => flex && css`
    flex: ${flex};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`}
`;

export const SidebarHeading = styled.div`
  margin: 6px 0 0 19px;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-weight: 500;
  letter-spacing: 0.26px;
  color: #5a6269;

  @media screen and (min-height: 800px) { 
    font-size: 14px;
  }
  @media screen and (max-height: 799px) { 
    font-size: 20px;
  }
`;

export const SidebarLinkHeading = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  color: hsl(0, 0%, 50%);
`;

export const SidebarQuickLayout = styled.div<{ direction?: 'row' | 'column' }>`
  display: flex;
  ${({ direction }) => direction === 'column' ? css`
    flex-direction: column;
    & > button:first-child {
      margin-bottom: 22px;
    }
  `:
    css`
    flex-direction: row;
    justify-content: space-between;
  `}
`;

export const BackLink = styled(Link)`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  color: hsl(0, 0%, 50%);
`;

const SLink = styled(Link)`
  position: absolute;
  right: 30px;
  top: 15px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: hsl(0, 0%, 55%);
  border-radius: 3px;
  background-color: hsl(206, 70%, 96%);
  text-decoration: none;
  padding: 7px 20px;
`;

export const SidebarBoxInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const SidebarBoxInnerItem = styled.div`
  flex: 1;
  display: block;
`;

const LogoTextStyle = styled(LogoText)`
  margin: 16px 0 0 20px;
`;

const LogoMarkStyle = styled(LogoMark)`
  margin: 16px 0 0px 21px;
`;

export const Section = styled.div<{ index: number, selected: number, completed: number }>`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
  :before {
    display: block;
    content: '';
    background-color: hsl(201, 77%, 71%);

    ${({ index, selected, completed }) => {
    if (index === selected) {
      return css`
            width: 6px;
            border-radius: 5px;
            margin-right: 15px;
            height: 20px;
          `;
    } else if (index <= completed) {
      return css`
            height: 20px;
            border-radius: 5px;
            width: 6px;
            margin-right: 15px;
            opacity: 0.35;
            background-color: #d0dce2
          `;
    } else {
      return css`
            height: 6px;
            width: 6px;
            border-radius: 50%;
            margin-right: 14px;
            background-color: hsl(200, 24%, 85%);
          `;
    }
  }}
  }

  > *:last-child {
    margin-left: auto;
  }
`;

export const SectionText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const SectionTitle = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  color: #585858;
`;


const Footer = styled.div`
  margin-top: auto;
`;

const SidebarToggle = styled.div<{ sidebarOpen: boolean }>`
  position: fixed;
  top: 45.5%;
  transition: 0.2s;
  cursor: pointer;
  margin: 0;
  border-radius: 3px;
  box-shadow: inset 0 0 20px 0 rgba(178, 201, 217, 0.15);
  border: solid 1px #c2d9e7;
  background-image: linear-gradient(to bottom, #e4eff4, #f1f5f7 97%);
  z-index: 4;
  ${({ sidebarOpen }) => sidebarOpen ? css`
    left: 280px;
    width: 17px;
    height: 38px;
    padding: 21px 0px 0px 1px;
    ` :
    css`
    left: 0px;
    width: 15px;
    height: 15px;
    padding: 22px 12px;
    `};
    ${({ sidebarOpen }) => sidebarOpen && css`
      display: none !important;
    ` }
`;

const SidebarButton = styled(Button)`
  width: 194px;
  margin-left: 18px;
  margin-bottom: 10px;
`;

/*const SectionMessage = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-style: italic;
  line-height: 1.67;
  color: #8d8f90;
  margin-top: 7px;

  @media screen and (min-height: 800px) { 
    font-size: 12px;
  }
  @media screen and (max-height: 799px) { 
    font-size: 18px;
  }
`;

const MessageContainer = styled.div`
  display: flex;
`;

const IconWrapper = styled.div`
  margin: -17px 10px 0 -4px;
`;*/

const ToggleIconWrapper = styled.div`
`;


export const SidebarLink: React.FC<{ title: string; to: string }> = ({ title, to }) => {
  return (
    <SidebarBox>
      <SidebarLinkHeading>{title}</SidebarLinkHeading>
      <SLink to={to}>Setup</SLink>
    </SidebarBox>
  );
};

const SectionLink: React.FC<{ index: number, selected: number, completed: number, title: string }> = ({ index, selected, completed, title }) => {
  const { setSelectedStep } = useContext(MenuContext);
  const handleClick = (index: number) => {
    if (completed >= index){
      setSelectedStep(index);
    }
  };
  return (
    <Section index={index} selected={selected} completed={completed} onClick={() => handleClick(index)}>
      <SectionText>
        <SectionTitle>{title}</SectionTitle>
      </SectionText>
    </Section>
  );
};



export const SideChildren: React.FC<any> = React.memo(() => {
  const { selectedStep, completedStep, isEdit } = useContext(MenuContext);
  //const { t } = useTranslation(['Common', 'CheckAndConfirm']);

  return (
    <Layout>
      <SidebarBox>
        {selectedStep >= 10 && <SidebarHeading>{isEdit ? '設定編集' : '初期設定'}</SidebarHeading>}
      </SidebarBox>
      {selectedStep < 10  &&
        <SidebarBox>
          <SectionLink index={0} selected={selectedStep} completed={completedStep} title='作業計測' />
          <SectionLink index={1} selected={selectedStep} completed={completedStep} title='履歴グラフ確認' />
          <SectionLink index={2} selected={selectedStep} completed={completedStep} title='タスクセット設定一覧' />
          <SectionLink index={3} selected={selectedStep} completed={completedStep} title='オペレーター一覧' />
          <br />
          <SectionLink index={10} selected={selectedStep} completed={completedStep} title='各種設定編集' />
        </SidebarBox>}
      {selectedStep >= 10 &&
        <SidebarBox>
          <SectionLink index={10} selected={selectedStep} completed={completedStep} title='オペレーター設定' />
          <SectionLink index={11} selected={selectedStep} completed={completedStep} title='作業判定エリア設定' />
          <SectionLink index={12} selected={selectedStep} completed={completedStep} title='身体部位判定エリア設定' />
          <SectionLink index={13} selected={selectedStep} completed={completedStep} title='ジョブ設定' />
          <SectionLink index={14} selected={selectedStep} completed={completedStep} title='ジョブマニュアル設定' />
          <SectionLink index={15} selected={selectedStep} completed={completedStep} title='タスク設定' />
          <SectionLink index={16} selected={selectedStep} completed={completedStep} title='タスクセット設定' />
          <SectionLink index={17} selected={selectedStep} completed={completedStep} title='最終確認' />
        </SidebarBox>}
    </Layout>
  );
});

const Sidebar: React.FC<any> = ({ children }) => {
  //const { t } = useTranslation(['Common', 'LiveView']);
  const { sidebarOpen, setSidebarOpen } = useContext(SidebarOpenContext);
  const { selectedStep, isEdit, setSelectedStep, setCompletedStep } = useContext(MenuContext);
  const { setFloorPlanStorage, deleteFloorPlanStorage } = useLocalStorage();
  const sidebarRef = useRef<HTMLDivElement>(null);

  const onLanguageChange = useCallback(() => {
    const language = i18n.language === 'ja' ? 'en' : 'ja';
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  }, []);

  const onDiscard = useCallback(() => {
    deleteFloorPlanStorage();
    axios.get(API_ENDPOINT + 'getSetup')
      .then((response) => {
        if (response.status === 200) {
          setFloorPlanStorage({...response.data});
          setSelectedStep(0);
          setCompletedStep(999);
        }
        else{
          setSelectedStep(10);
          setCompletedStep(0);
        }
      })
      .catch((error) => {
        console.error(error);
        setSelectedStep(10);
        setCompletedStep(0);
      });
  }, [setFloorPlanStorage, deleteFloorPlanStorage, setSelectedStep, setCompletedStep]);

  return (
    <>
      {sidebarOpen &&
        <Container sidebarOpen={sidebarOpen}>
          <InnerContainer ref={sidebarRef}>
            <LogoContainer onClick={() => { window.location.href = '/'; }}>
              <LogoMarkStyle />
              {sidebarOpen && <LogoTextStyle />}
            </LogoContainer>
            {sidebarOpen && children}
            {sidebarOpen && 
              <Footer>
                {isEdit && selectedStep >= 10 &&
                  <SidebarButton onClick={onDiscard} size='small' design='secondary'>保存せずに戻る</SidebarButton>}
                {1===2 && <LanguageSwitch onLanguageToggle={onLanguageChange} />}
              </Footer>}
          </InnerContainer>
        </Container>}
      {selectedStep === 100 &&
        <SidebarToggle onClick={() => setSidebarOpen(!sidebarOpen)} sidebarOpen={sidebarOpen}>
          <ToggleIconWrapper>
            <Icon icon={sidebarOpen ? 'Left' : 'Menu'} size={12} color='dimmed' />
          </ToggleIconWrapper>
        </SidebarToggle>}
    </>
  );
};

export default Sidebar;
